import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { attentionCallApi } from 'shared/services/attentionCallApi';
import { queryKeys } from '../queryConfig';

export interface AttentionCallsFilters {
  company?: string;
  status?: string;
  severity?: string;
  page?: number;
  limit?: number;
}

export const useAttentionCalls = (filters: AttentionCallsFilters = {}) => {
  const queryParams = {
    page: filters.page || 1,
    limit: filters.limit || 20,
    ...(filters.company && { company: filters.company }),
    ...(filters.status && { status: filters.status }),
    ...(filters.severity && { severity: filters.severity }),
  };

  return useQuery({
    queryKey: queryKeys.attentionCalls.list(queryParams, filters.company || ''),
    queryFn: () => attentionCallApi.getAll(queryParams),
    placeholderData: keepPreviousData,
  });
};

export const useAttentionCallStats = (company?: string) => {
  return useQuery({
    queryKey: queryKeys.attentionCalls.stats(company || ''),
    queryFn: () => attentionCallApi.getStats({ company }),
  });
};

export const useDeleteAttentionCall = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => attentionCallApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.attentionCalls.all });
    },
  });
};

